import lodash from "lodash";
import Cell from './Cell';
import Meta from "./Meta";

export default class Row {

    constructor(options) 
    {        
        options = options || {};

        this.meta  = null;
        this.id    = null;
        this.cells = {};

        if( ! options.hasOwnProperty('cells') ) {
            options = { cells: options };
        }
        
        this.addCells(options.cells);

        if( options.hasOwnProperty('id') ) {
            this.id = options.id;
        }

        if( options.hasOwnProperty('meta') ) {
            this.setMeta(options.meta);
        }
    }

    setMeta(meta) {

        if(meta && ! ( meta instanceof Meta ) ) {
            meta = new Meta(meta);
        };

        this.meta = meta;
        return this;
    }

    addCell(columnIndex, cell) {

        if( ! (cell instanceof Cell) ) {
            cell = new Cell(cell);
        };

        if( ! this.cells.hasOwnProperty(columnIndex) ) {
            this.cells[columnIndex] = [];
        }

        this.cells[columnIndex].push(cell);

        return this;
    }

    addCells(cells) {

        let self = this;
        for(let columnId in cells) {
            let cell = cells[columnId];

            if( lodash.isArray(cell) ) {                
                cell.map(function(v){
                    self.addCell(columnId, v);
                })
            } else {
                self.addCell(columnId, cell);
            }
        }

        return this;
    }
}


// WEBPACK FOOTER //
// ./src/components/common/table_v3/Row.js